/**
 * Test IDs for QA automation.
 */
export const testIds = {
  invoiceSeparationModalSelectAll:
    "invoice-separation-modal-select-all",
  invoiceSeparationModalOrder: (shipmentId: string) =>
    `invoice-separation-modal-order-${shipmentId}`,
  invoiceSeparationModalCancel: "invoice-separation-modal-cancel",
  invoiceSeparationModalSeparate: "invoice-separation-modal-separate",
} as const;
